import React, { useEffect, useState } from 'react';
import { format, addDays } from 'date-fns';
import { db } from '../../firebase';
import { collection, doc, getDoc, getDocs, setDoc, addDoc, deleteDoc } from 'firebase/firestore';
import { FaEdit, FaTrashAlt } from "react-icons/fa";
import GetUserData from '../../Hooks/GetUserData';
import { useUserPermissions } from '../../Hooks/GetUserPermissions';

const diasSemana = ['lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado', 'domingo'];

const CalendarioSemanalTabla = ({ lunesSeleccionado, hubId, empresaId }) => {
  const [empleados, setEmpleados] = useState([]);
  const [horasTrabajadas, setHorasTrabajadas] = useState({});
  const [guardado, setGuardado] = useState(false);

  const [facturacionTotal, setFacturacionTotal] = useState({});
  const [facturacionManana, setFacturacionManana] = useState({});

  const [mostrarFormulario, setMostrarFormulario] = useState(false);
  const [nuevoNombre, setNuevoNombre] = useState('');
  const [nuevoCosteHora, setNuevoCosteHora] = useState('');
  const [nuevoNombreCompleto, setNuevoNombreCompleto] = useState('');
  const [nuevoNif, setNuevoNif] = useState('');
  // Estados para edición
  const [empleadoEditando, setEmpleadoEditando] = useState(null);
  const [nombreEditando, setNombreEditando] = useState('');
  const [costeHoraEditando, setCosteHoraEditando] = useState('');
  const [bloqueado, setBloqueado] = useState(false);

  const idSemana = format(lunesSeleccionado, 'yyyy-MM-dd');

  const empleadosRef = collection(db, 'private-hubs', hubId, 'empleados');  
  const semanaDocRef = doc(db, 'private-hubs', hubId, 'Empresas', empresaId, 'semanas', idSemana);

  const { userData, loadingB } = GetUserData();

  const isSuperAdmin = !loadingB && userData?.hubId?.includes('__superadmin__');

  const { permisos, loading } = useUserPermissions();

  const isAdmin = !loading && (
    permisos.verCalendario === 'lectura_escritura' || isSuperAdmin
  );





  const cargarEmpleados = async () => {
    try {
      const querySnapshot = await getDocs(empleadosRef);
      const lista = querySnapshot.docs.map(doc => ({
        id: doc.id,
        ...doc.data()
      }));
      setEmpleados(
        lista.sort((a, b) => a.nombre.localeCompare(b.nombre))
      );
    } catch (error) {
      console.error('Error cargando empleados:', error);
    }
  };

  const cargarHorasYFacturacion = async () => {
    try {
      const docSnap = await getDoc(semanaDocRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setHorasTrabajadas(data.empleados || {});
        setFacturacionTotal(data.facturacionTotal || {});
        setFacturacionManana(data.facturacionManana || {});
        setBloqueado(data.bloqueado || false);
      } else {
        setHorasTrabajadas({});
        setFacturacionTotal({});
        setFacturacionManana({});
        setBloqueado(false);
      }
    } catch (error) {
      console.error('Error cargando horas y facturación:', error);
    }
  };

  useEffect(() => {
    if (hubId) {
      cargarEmpleados();
      cargarHorasYFacturacion();
    }
    //eslint-disable-next-line 
  }, [hubId, idSemana, empresaId]);

  const actualizarHoras = (idEmpleado, dia, turno, valor) => {
    setHorasTrabajadas(prev => ({
      ...prev,
      [idEmpleado]: {
        ...prev[idEmpleado],
        [dia]: {
          ...prev[idEmpleado]?.[dia],
          [turno]: valor === '' ? '' : Number(valor)
        }
      }
    }));
  };

  const actualizarFacturacionTotal = (dia, valor) => {
    setFacturacionTotal(prev => ({
      ...prev,
      [dia]: valor === '' ? '' : Number(valor)
    }));
  };

  const actualizarFacturacionManana = (dia, valor) => {
    setFacturacionManana(prev => ({
      ...prev,
      [dia]: valor === '' ? '' : Number(valor)
    }));
  };

  const guardarHorasYFacturacion = async () => {
    try {
      await setDoc(semanaDocRef, {
        empleados: horasTrabajadas,
        facturacionTotal,
        facturacionManana
      });
      setGuardado(true);
      setTimeout(() => setGuardado(false), 2000);
    } catch (error) {
      console.error('Error guardando horas y facturación:', error);
    }
  };

  const crearEmpleado = async () => {
    if (
      !nuevoNombre.trim() ||
      !nuevoCosteHora ||
      isNaN(Number(nuevoCosteHora)) ||
      Number(nuevoCosteHora) < 0
    ) {
      alert('Por favor, ingresa un nombre válido y un coste/hora positivo.');
      return;
    }

    const empleado = {
      nombre: nuevoNombre.trim(),
      nombreCompleto: nuevoNombreCompleto.trim(),
      nif: nuevoNif.trim(),
      costeHora: Number(nuevoCosteHora)
    };

    try {
      const docRef = await addDoc(empleadosRef, empleado);
      setEmpleados(prev => [...prev, { id: docRef.id, ...empleado }]);
      setNuevoNombre('');
      setNuevoNombreCompleto('');
      setNuevoNif('');
      setNuevoCosteHora('');
      setMostrarFormulario(false);
    } catch (error) {
      console.error('Error creando empleado:', error);
    }
  };



  const eliminarEmpleado = async (idEmpleado) => {
    try {
      await deleteDoc(doc(db, 'private-hubs', hubId, 'empleados', idEmpleado));
      setEmpleados(prev => prev.filter(e => e.id !== idEmpleado));
      setHorasTrabajadas(prev => {
        const nuevo = { ...prev };
        delete nuevo[idEmpleado];
        return nuevo;
      });
    } catch (error) {
      console.error('Error eliminando empleado:', error);
    }
  };

  // Funciones para edición
  const iniciarEdicion = (empleado) => {
    setEmpleadoEditando(empleado.id);
    setNombreEditando(empleado.nombre);
    setCosteHoraEditando(empleado.costeHora.toString());
  };

  const cancelarEdicion = () => {
    setEmpleadoEditando(null);
    setNombreEditando('');
    setCosteHoraEditando('');
  };

  const guardarEdicion = async () => {
    if (!nombreEditando.trim() || isNaN(Number(costeHoraEditando)) || Number(costeHoraEditando) < 0) {
      alert('Por favor, ingresa un nombre válido y un coste/hora positivo.');
      return;
    }

    try {
      const empleadoRef = doc(db, 'private-hubs', hubId, 'empleados', empleadoEditando);
      await setDoc(empleadoRef, {
        nombre: nombreEditando.trim(),
        costeHora: Number(costeHoraEditando)
      }, { merge: true });

      setEmpleados(prev =>
        prev.map(e => e.id === empleadoEditando ? { ...e, nombre: nombreEditando.trim(), costeHora: Number(costeHoraEditando) } : e)
      );

      cancelarEdicion();
    } catch (error) {
      console.error('Error guardando empleado editado:', error);
    }
  };

  const guardarDefinitivamenteSemana = async () => {
    try {
      await setDoc(semanaDocRef, {
        empleados: horasTrabajadas,
        facturacionTotal,
        facturacionManana,
        bloqueado: true
      }, { merge: true });

      setBloqueado(true);
      alert('Semana guardada de forma definitiva. Ya no se puede modificar.');
    } catch (error) {
      console.error('Error guardando semana de forma definitiva:', error);
      alert('Error al guardar la semana de forma definitiva.');
    }
  };

  const calcularKPI = () => {
    const kpi = {};

    diasSemana.forEach(dia => {
      let costeManana = 0;
      let costeTarde = 0;

      empleados.forEach(emp => {
        const horas = horasTrabajadas[emp.id]?.[dia];
        const costeHora = emp.costeHora || 0;

        if (horas) {
          costeManana += costeHora * (Number(horas.manana) || 0);
          costeTarde += costeHora * (Number(horas.tarde) || 0);
        }
      });

      const costeDia = costeManana + costeTarde;
      const factManana = facturacionManana[dia] || 0;
      const factTotal = facturacionTotal[dia] || 0;
      const factTarde = factTotal - factManana;

      kpi[dia] = {
        manana: factManana > 0 ? (costeManana * 100 / factManana).toFixed(1) : '-',
        tarde: factTarde > 0 ? (costeTarde * 100 / factTarde).toFixed(1) : '-',
        dia: factTotal > 0 ? (costeDia * 100 / factTotal).toFixed(1) : '-',
      };
    });

    return kpi;
  };

  const calcularHorasTotales = () => {
    const totales = {};

    diasSemana.forEach(dia => {
      let totalManana = 0;
      let totalTarde = 0;

      empleados.forEach(emp => {
        const horasDia = horasTrabajadas[emp.id]?.[dia] || {};
        totalManana += Number(horasDia.manana) || 0;
        totalTarde += Number(horasDia.tarde) || 0;
      });

      totales[dia] = {
        manana: totalManana.toFixed(2),
        tarde: totalTarde.toFixed(2),
        total: (totalManana + totalTarde).toFixed(2)
      };
    });

    return totales;
  };

  const kpi = calcularKPI();
  const horasTotales = calcularHorasTotales();


  if (!hubId) {
    return <p>Selecciona un hub para continuar.</p>;
  }

  const semanaFinalizada = addDays(lunesSeleccionado, 6) < new Date();

  return (
    <div className="calendar-box">
    {mostrarFormulario && (
      <div className="data-box acciones-form mb-4 max-w-sm" style={{ padding: '1rem' }}>
        <input
          type="text"
          placeholder="Nombre corto"
          value={nuevoNombre}
          onChange={e => setNuevoNombre(e.target.value)}
        />
        <input
          type="text"
          placeholder="Nombre completo"
          value={nuevoNombreCompleto}
          onChange={e => setNuevoNombreCompleto(e.target.value)}
        />
        <input
          type="text"
          placeholder="NIF"
          value={nuevoNif}
          onChange={e => setNuevoNif(e.target.value)}
        />
        <input
          type="number"
          min="0"
          step="0.01"
          placeholder="Coste €/hora"
          value={nuevoCosteHora}
          onChange={e => setNuevoCosteHora(e.target.value)}
        />
        <div style={{ display: 'flex', gap: '10px' }}>
          <button onClick={crearEmpleado} className="seccion-btn" style={{ flex: 1 }}>Guardar</button>
          <button onClick={() => setMostrarFormulario(false)} className="btn-eliminar" style={{ flex: 1 }}>Cancelar</button>
        </div>
      </div>
    )}

      <div className='table-responsive'>
        <table className="data-table" style={{marginTop: '0px'}}>
          <thead>
            <tr>
              <th style={{zIndex: '9999'}}>Empleado</th>
              <th>Coste€/h</th>
              {diasSemana.map((dia, i) => (
                <th key={dia} style={{textAlign: 'center', lineHeight: 1.2}}>{dia} {format(addDays(lunesSeleccionado, i), 'dd/MM')}</th>
              ))}
              <th></th>
            </tr>
          </thead>
          <tbody>
            {empleados.map((empleado) => (
              <tr key={empleado.id}>
                <td style={{lineHeight: 1.5}}>
                  {empleadoEditando === empleado.id ? (
                    <input
                      type="text"
                      value={nombreEditando}
                      onChange={e => setNombreEditando(e.target.value)}
                      style={{ fontSize: '0.9rem', padding: '4px' }}
                    />
                  ) : (
                    empleado.nombre
                  )}
                </td>
                <td>
                  {empleadoEditando === empleado.id ? (
                    <input
                      type="number"
                      min="0"
                      step="0.01"
                      value={costeHoraEditando}
                      onChange={e => setCosteHoraEditando(e.target.value)}
                      style={{ width: '60px', fontSize: '0.9rem', padding: '4px' }}
                    />
                  ) : (
                    empleado.costeHora.toFixed(2)
                  )}
                </td>
                {diasSemana.map((dia) => {
                  const datosDia = horasTrabajadas[empleado.id]?.[dia] || {};
                  const manana = datosDia.manana ?? '';
                  const tarde = datosDia.tarde ?? '';
                  const total =
                    (!isNaN(manana) || manana === '') && (!isNaN(tarde) || tarde === '')
                      ? (Number(manana || 0) + Number(tarde || 0)).toFixed(2)
                      : '';

                  return (
                    <td key={dia} style={{ minWidth: '80px', maxWidth: '150px' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '4px', textAlign: 'center', alignItems: 'center' }}>
                        <label style={{ display: 'block', marginBottom: '4px' }}>Mañana:</label>
                        <input
                          type="number"
                          min="0"
                          step="0.25"
                          value={manana}
                          onChange={e => actualizarHoras(empleado.id, dia, 'manana', e.target.value)}
                          readOnly={bloqueado || !isAdmin}
                          style={{ marginBottom: '4px', textAlign: 'center', width: '50%'  }}
                        />
                        <label style={{ display: 'block', marginBottom: '4px' }}>Tarde:</label>
                        <input
                          type="number"
                          min="0"
                          step="0.25"
                          value={tarde}
                          onChange={e => actualizarHoras(empleado.id, dia, 'tarde', e.target.value)}
                          readOnly={bloqueado || !isAdmin}
                          style={{ marginBottom: '4px', textAlign: 'center', width: '50%'  }}
                        />
                        <label style={{ display: 'block', marginBottom: '4px' }}>Total día:</label>
                        <input
                          type="text"
                          value={total}
                          readOnly
                          style={{ fontWeight: 'bold', backgroundColor: '#f0f0f0', textAlign: 'center', width: '50%'  }}
                        />
                      </div>
                    </td>
                  );
                })}
                <td>
                  {empleadoEditando === empleado.id ? (
                    <>
                      <button onClick={guardarEdicion} className="btn-eliminar" style={{ margin: '5px' }}>Guardar</button>
                      <button onClick={cancelarEdicion} className="btn-eliminar">Cancelar</button>
                    </>
                  ) : (
                    <>
                      {isSuperAdmin && (
                        <button onClick={() => eliminarEmpleado(empleado.id)} className="btn-eliminar" title="Eliminar empleado">
                          <FaTrashAlt />
                        </button>
                      )}
                      {isSuperAdmin && (
                        <button onClick={() => iniciarEdicion(empleado)} className="btn-eliminar" title='Editar empleado' style={{margin: '5px'}}>
                          <FaEdit />
                        </button>
                      )}
                    </>
                  )}
                </td>
              </tr>
            ))}

            <tr style={{ backgroundColor: '#f0f0f0', fontWeight: '600' }}>
              <td>Horas Totales</td>
              <td></td>
              {diasSemana.map(dia => (
                <td key={dia} style={{ textAlign: 'center' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.85rem' }}>Mañana:</label>
                    <input
                      type="text"
                      value={horasTotales[dia]?.manana || '0.00'}
                      readOnly
                      style={{ margin: '2px 0', textAlign: 'center', width: '50%'   }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.85rem' }}>Tarde:</label>
                    <input
                      type="text"
                      value={horasTotales[dia]?.tarde || '0.00'}
                      readOnly
                      style={{ margin: '2px 0', textAlign: 'center', width: '50%'   }}
                    />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.85rem' }}>Total:</label>
                    <input
                      type="text"
                      value={horasTotales[dia]?.total || '0.00'}
                      readOnly
                      style={{ margin: '2px 0', textAlign: 'center', width: '50%'    }}
                    />
                  </div>
                </td>
              ))}
              <td></td>
            </tr>


            <tr style={{ backgroundColor: '#acd9fa', fontWeight: '600' }}>
              <td>Facturación</td>
              <td></td>
              {diasSemana.map((dia) => {
                const totalDia = facturacionTotal[dia] ?? '';
                const manana = facturacionManana[dia] ?? '';
                const tarde =
                  totalDia !== '' && manana !== '' && !isNaN(totalDia) && !isNaN(manana)
                    ? (Number(totalDia) - Number(manana)).toFixed(2)
                    : '';
                return (
                  <td key={dia} style={{ textAlign: 'center', verticalAlign: 'top' }}>

                    <div>
                      <label style={{ display: 'block', marginBottom: '4px' }}>Mañana:</label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={manana}
                        onChange={e => actualizarFacturacionManana(dia, e.target.value)}
                        style={{ marginBottom: '4px', textAlign: 'center', width: '50%'    }}
                        readOnly={bloqueado || !isAdmin}
                      />
                    </div>
                    <div>
                      <span>
                        <label style={{ display: 'block', margin: '4px' }}>Tarde:</label>
                        <input
                          value={(tarde !== '' ? tarde : '-')}
                          style={{ marginBottom: '4px', textAlign: 'center', width: '50%'    }}
                          readOnly
                        />

                      </span>
                    </div>
                    <div>
                      <label style={{ display: 'block', margin: '4px' }}>Total día:</label>
                      <input
                        type="number"
                        step="0.01"
                        min="0"
                        value={totalDia}
                        onChange={e => actualizarFacturacionTotal(dia, e.target.value)}
                        style={{ marginBottom: '4px', textAlign: 'center', width: '50%'    }}
                        readOnly={bloqueado || !isAdmin}
                      />
                    </div>
                  </td>
                );
              })}
              <td></td>
            </tr>
            <tr style={{ backgroundColor: '#def7ec', fontWeight: '600' }}>
              <td>KPI</td>
              <td></td>
              {diasSemana.map(dia => (
                <td key={dia} style={{ textAlign: 'center' }}>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.85rem' }}>Mañana:</label>
                    <input
                        type="text"
                        value={kpi[dia]?.manana + '%'}
                        style={{ margin: '4px', textAlign: 'center', width: '50%'    }}
                        readOnly
                      />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.85rem' }}>Tarde:</label>
                      <input
                        type="text"
                        value={kpi[dia]?.tarde + '%'}
                        style={{ margin: '4px', textAlign: 'center', width: '50%'    }}
                        readOnly
                      />
                  </div>
                  <div>
                    <label style={{ display: 'block', fontSize: '0.85rem', textAlign: 'center'  }}>Total:</label>
                    <input
                        type="text"
                        value={kpi[dia]?.dia + '%'}
                        style={{ margin: '4px', textAlign: 'center', width: '50%'    }}
                        readOnly
                      />
                  </div>
                </td>
              ))}
              <td></td>
            </tr>

          </tbody>
        </table>
      </div>
      
      <button onClick={guardarHorasYFacturacion} className="seccion-btn" style={{ margin: '1rem' }}>
        Guardar semana
      </button>


      {semanaFinalizada && !bloqueado && (
        <button
          onClick={() => {
            const confirmacion = window.confirm("¿Estás seguro de que deseas guardar la semana de forma definitiva? Esta acción no se puede deshacer.");
            if (confirmacion) {
              guardarDefinitivamenteSemana();
            }
          }}
          className="seccion-btn"
          style={{ margin: '1rem', backgroundColor: '#991b1b', color: 'white' }}
        >
          Bloquear semana
        </button>
      )}


      {!mostrarFormulario && isSuperAdmin && (
        <button onClick={() => setMostrarFormulario(true)} className="seccion-btn mb-4" style={{ margin: '1rem' }}>
          + Añadir empleado
        </button>
      )}

      {guardado && (
        <p style={{ color: '#15803d', marginTop: '0.5rem', fontWeight: '600' }}>
          Datos guardados correctamente
        </p>
      )}
    </div>
  );
};

export default CalendarioSemanalTabla;
